<template>
  <div>
    <div>
          <quickQuery @handleQuery="handleQuery" @quickQuery="quickQuery" :initSearchTime="searchTime" :isDownload="false"  :isMounted="false" style="text-align: right" />
      </div>
    <div v-loading="loading" style="width:100%;height:100%;margin-top:12px">

      <div id="compareCharts" class="compareCharts" :style="{width:'100%',height:'calc(100vh - 275px)'}"></div>
    </div>
  </div>
</template>
<script>
import quickQuery from '../../statistics/components/generalOrQuickQuery.vue'
// import * as echarts from "echarts"
import { mapState } from 'vuex'
export default {
  components:{
    quickQuery,
  },
  props:{
    dataList:{
    },
    _loading:{
      type:Boolean,
      default:false,
    }
  },
  data(){
    return{
      loading:false,
      chartHeight:500,
      searchTime:[new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)],
      compareCharts: undefined,
      form:undefined,
      vehicles:undefined,
    }
  },
  computed:{
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch:{
    _loading(newval){
      this.loading = newval;
    },
    dataList(){
      this.$nextTick(()=>{
        // console.log(this.dataList);
        this.setDataIntoChart(this.dataList);
        this.compareCharts.resize();
      });
      deep: true
    }
  },
  methods:{
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    handleQuery(val){
      this.form = val;
      this.vehicles = this.getSelectedVehicles();
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      this.getList();
    },
    quickQuery(val){
      this.form = val;
      this.vehicles = this.getSelectedVehicles();
      this.getList();
    },
    getList(){
      // console.log("chart")
      this.loading = true;
      this.$api.scoreInfo({
        vehicles: this.vehicles,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        OperatorID: this.operator.OperatorId + "",//1668
        // OperatorID: 1668 + "",
      })
      .then((res)=>{
        if(res && res.code == 200){

          this.setDataIntoChart(res.data);

          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
      })
    },
    setDataIntoChart(data){
      let xAxis_data = [];
      let yAxis_data = [];
      data.forEach(element => {
        xAxis_data.push(element.score);
        yAxis_data.push(element.carNo);
      });
      // console.log(xAxis_data,yAxis_data)
      
      switch(yAxis_data.length){
        case 1:
          this.compareCharts.resize({height: yAxis_data.length * 35 + 70});
          break;
        case (2 || 3):
          this.compareCharts.resize({height: yAxis_data.length * 35 + 50});
          break;
        default:
          this.compareCharts.resize({height: yAxis_data.length * 35 + 20});
      }


      var option = {
        //图表位置
        grid: {
          left: '3%',
          right: '2%',
          bottom: '1%',
          containLabel: true
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     orient: 'vertical',
        //   },
        //   {
        //     type: 'inside',
        //     orient: 'vertical',
        //   }
        // ],
        //X轴
        xAxis: {
          type: "value",
          axisTick: {show: false},
          //不显示X轴刻度线和数字
          splitLine: { show: true },
          axisLabel: { show: true },
        },
        yAxis: [{
          type: "category",
          data: yAxis_data,
          //升序
          inverse: true,
          axisLabel: {
            textStyle: {
              show:true,
              color: "#0F1A3A",
              fontSize: '12',
            }
          },
          //key和图间距
          offset: 10,
          nameTextStyle: {
            fontSize:12,
            padding: [0, 0, 0, -10]
          },
        },],
        series: [
          {
            name: this.$t("driver.score"),
            type: 'bar',
            color:"#91baff",
            data: xAxis_data,
            
          },
        ]
      };
      this.compareCharts.setOption(option);
    },
    initChart(){
      this.compareCharts = echarts.init(document.getElementById("compareCharts"));
      let option = {
        title: {
          text: this.$t('driver.vehiScoreCompare')//车辆得分对比
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: '分数',
            type: 'bar',
            color:"#4d91ff",
            data: [],
          },
        ]
      };
      this.compareCharts.setOption(option);
    },
    setResize(){
      this.compareCharts.resize();
    }
  },
  mounted(){
    this.initChart();
    window.addEventListener('resize',this.setResize);
    this.setResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
}
</script>
<style lang="scss" scoped>
.compareCharts{
  width: 100;
  height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;

}
</style>